import './instagram_message_base_parser.js.coffee'
Namespace 'Models.Parsers'

class Models.Parsers.InstagramMessageUnsupportedParser extends Models.Parsers.InstagramMessageBaseParser
  canHandle: (messageJSON) ->
    true

  parse: (messageJSON) ->
    builder = new Models.Builders.InstagramMessageUnsupportedBuilder
    @_doParse(builder, messageJSON)
    message = @_getMessage(messageJSON)
    builder.isKeepconUnsupported = (message.is_unsupported || 'false') == 'false'
    return builder.build()
